import { get } from 'api/client';
import { createSearchFromParams } from 'utils/url';
import { getAiHubBaseURL } from 'app/config/aiHubEndpointMode';

export type AIContentOptions = {
  remainingAttempts: {
    image: number;
    text: number;
    all: number;
  };
  availableAttempts: {
    image: number;
    text: number;
    all: number;
  };
};

export type TokenUsageByModel = {
  provider: string;
  model: string;
  requestType: string;
  inputTokens: number;
  outputTokens: number;
  totalTokens: number;
  estimatedCostUsd: number;
  requestCount: number;
};

export type TokenUsageLog = {
  id: number;
  provider: string;
  model: string;
  requestType: string;
  endpoint: string | null;
  inputTokens: number;
  outputTokens: number;
  totalTokens: number;
  estimatedCostUsd: number;
  createdAt: string;
};

export type TokenUsageResponse = {
  totals: {
    inputTokens: number;
    outputTokens: number;
    totalTokens: number;
    estimatedCostUsd: number;
    requestCount: number;
  };
  byModel: TokenUsageByModel[];
  recentLogs: TokenUsageLog[];
};

export const AIContentApi = {
  async options({
    plan_type,
  }: {
    plan_type: string;
  }): Promise<AIContentOptions> {
    return get<AIContentOptions>(
      `/options${createSearchFromParams({ plan_type })}`,
      {
        baseURL: getAiHubBaseURL(),
      },
    );
  },

  async tokenUsage(): Promise<TokenUsageResponse> {
    return get<TokenUsageResponse>('/token-usage', {
      baseURL: getAiHubBaseURL(),
    });
  },
};
